const ROOT = 'AGENCY_CONTRACT_V2_EDITOR_';

const actionTypes = {
  LOAD_COMBINATIONS_REQUEST: `${ROOT}LOAD_COMBINATIONS_REQUEST`,
  LOAD_COMBINATIONS_SUCCESS: `${ROOT}LOAD_COMBINATIONS_SUCCESS`,
  LOAD_COMBINATIONS_ERROR: `${ROOT}LOAD_COMBINATIONS_ERROR`,
  CLEAR_COMBINATIONS: `${ROOT}CLEAR_COMBINATIONS`,
  SUBMIT_REQUEST: `${ROOT}SUBMIT_REQUEST`,
  SUBMIT_SUCCESS: `${ROOT}SUBMIT_SUCCESS`,
  SUBMIT_FAILED: `${ROOT}SUBMIT_FAILED`,
  CLEAR_SUBMIT_ERRORS: `${ROOT}CLEAR_SUBMIT_ERRORS`,
  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actionTypes;
